/** Posts registered for SEO/routing but not yet published (hidden from blog index and related links). */
export const BLOG_STUB_SLUGS = new Set([]);
